import { render, staticRenderFns } from "./EmailBuilder.vue?vue&type=template&id=448b99f0&scoped=true&"
import script from "./EmailBuilder.vue?vue&type=script&lang=js&"
export * from "./EmailBuilder.vue?vue&type=script&lang=js&"
import style0 from "./EmailBuilder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EmailBuilder.vue?vue&type=style&index=1&id=448b99f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448b99f0",
  null
  
)

export default component.exports